import { useState } from "react";

export const usePreviewAnswers = () => {
  const { 0: answers, 1: setAnswers } = useState(new Map());
  const { 0: comments, 1: setComments } = useState(new Map());

  return {
    get: (id) => answers.get(id) || "",
    set: (id, value) => {
      setAnswers((prevAnswers) => {
        const newAnswers = new Map(prevAnswers);
        newAnswers.set(id, value);
        return newAnswers;
      });
    },
    remove: (id) => {
      setAnswers((prevAnswers) => {
        const newAnswers = new Map(prevAnswers);
        newAnswers.delete(id);
        return newAnswers;
      });
    },
    isAnswered: (id) => {
      const answer = answers.get(id);
      return answer && answer?.length > 0;
    },
    getComment: (id) => comments.get(id) || "",
    setComment: (id, value) => {
      setComments((prevComments) => {
        const newComments = new Map(prevComments);
        newComments.set(id, value);
        return newComments;
      });
    },
  };
};
